<template>
  <div class="coupon-list-wrap">
    <el-card class="coupon-list-body">
      <el-row class="common-con-btns mb10">
        <el-button size="small" type="primary" @click="addshops">添加店铺</el-button>
        <el-button type="primary" size="small" @click="delShop(null,1)">删除</el-button>
      </el-row>
      <el-form :inline="true" :model="searchForm" ref="searchForm" size="mini">
        <el-form-item label="筛选"></el-form-item>
        <el-form-item>
          <el-input
            class="select-input"
            placeholder="请输入门店id"
            size="mini"
            v-model="searchForm.shop_id"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="onSearch" size="mini" type="primary">筛选</el-button>
          <el-button @click="onReset" size="mini">重置</el-button>
        </el-form-item>
      </el-form>
      <el-table
        class="page-wrap"
        :data="shopList"
        ref="listTable"
        row-key="id"
        @selection-change="changeSelect"
        header-row-class-name="table-black-header"
        style="width: 100%"
      >
        <el-table-column align="center" type="selection" :reserve-selection="true" min-width="55"></el-table-column>
        <el-table-column label="店铺id" prop="shop_id"></el-table-column>
        <el-table-column label="店铺名称" prop>
          <template slot-scope="scope">
            <span>{{scope.row.shop?scope.row.shop.name:''}}</span>
          </template>
        </el-table-column>
        <el-table-column label="店主加值" prop>
          <template slot-scope="scope">
            <span>{{scope.row.shop_add_value}}</span>
          </template>
        </el-table-column>
        <el-table-column label="有效期" prop>
          <template slot-scope="scope">
            <span>{{scope.row.valid_day+'天'}}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" prop>
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="delShop(scope.row,2)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!--页码信息-->
      <div class="ftc mt10">
        <el-pagination
          background
          layout="total, prev, pager, next, jumper"
          :total="page.total"
          :page-size="page.pageSize"
          @current-change="currentPageChange"
          :current-page="page.currentPage"
        ></el-pagination>
      </div>
    </el-card>
    <!-- 添加关联店铺 -->
    <el-dialog :visible.sync="remark.show" title="添加关联门店" width="500px">
      <el-form :rules="rules" :model="remark.form" ref="couponForm" label-width="100px">
        <el-form-item label="输入门店id" prop="shop_ids">
          <el-col :span="10">
            <el-input
              type="textarea"
              style="width:200px"
              placeholder="门店id，用逗号隔开"
              :rows="5"
              v-model="remark.form.shop_ids"
            ></el-input>
          </el-col>
        </el-form-item>
      </el-form>
      <div class="dialog-footer ftc" slot="footer">
        <el-button @click="onSubmit" type="primary">确认</el-button>
        <el-button @click="remark.show = false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { couponApi } from "@/api/coupon";
import { mapState } from "vuex";
export default {
  data() {
    return {
      searchForm: {
        shop_id: "",
        id: ""
      },
      page: {
        currentPage: 1,
        pageSize: 20,
        total: 1
      },
      shopList: [],
      remark: {
        show: false,
        form: {
          shop_ids: "",
          id: ""
        }
      },
      rules: {
        shop_ids: [{ required: true, message: "请填写门店id", trigger: "blur" }]
      },
      coupon_id: "",
      checklist: []
    };
  },
  mounted() {
    this.coupon_id = parseInt(this.$route.query.coupon_id);
    this.searchForm.id = this.coupon_id;
    console.log(this.$route.query.coupon_id);
    this.getShop(this.coupon_id);
  },
  methods: {
    /**
     * 获取关联店铺数据
     */
    getShop(id) {
      let pam = {
        id: id,
        shop_id: this.searchForm.shop_id,
        page: this.page.currentPage,
        per_page: this.page.pageSize
      };
      this.$EpetJs.Common.get(
        couponApi.getGeneralCouponUrl + "/" + id + "/shops",
        pam
      ).then(res => {
        if (res) {
          this.shopList = res.data.data;
          if (res.data.meta && res.data.meta.pagination) {
            this.page.total = res.data.meta.pagination.total;
          }
        }
      });
    },
    /**
     * 当前页改变
     * @param val
     */
    currentPageChange(val) {
      this.page.currentPage = val;
      this.getShop(this.coupon_id);
    },
    /**
     * 筛选
     */
    onSearch() {
      this.page.currentPage = 1;
      this.getShop(this.coupon_id);
    },
    /**
     * 重置
     */
    onReset() {
      this.page.currentPage = 1;
      this.$refs.listTable.clearSelection();
      this.checklist = [];
      this.searchForm.shop_id = "";
      this.getShop(this.coupon_id);
    },
    /**
     * 添加店铺
     * @param row
     */
    addshops() {
      this.remark.show = true;
      this.remark.form.shop_ids = "";
    },
    changeSelect(val) {
      this.checklist = val;
    },
    /**
     * 确定添加店铺
     */
    onSubmit() {
      this.remark.form.id = this.coupon_id;
      this.$refs.couponForm.validate(valid => {
        if (valid) {
          //新增
          this.$EpetJs.Common.post(
            couponApi.addGeneralCoupon + "/" + this.coupon_id + "/shop",
            this.remark.form
          ).then(res => {
            if (res) {
              this.remark.show = false;
              this.$message.success("成功！");
              this.getShop(this.coupon_id);
            }
          });
        }
      });
    },
    /**
     * 删除店铺
     * @param row 本条店铺数据
     */
    delShop(row, type) {
      let shop_ids = "";
      if (type == 1) {
        let arr = [];
        this.checklist.map(item => {
          arr.push(item.shop_id);
        });
        shop_ids = arr.join(",");
      } else {
        shop_ids = row.shop_id.toString();
      }
      this.$EpetJs.Common.confirm("是否确定删除该店铺", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$EpetJs.Common.delete(
            couponApi.getGeneralCouponUrl + "/" + this.coupon_id + "/shop",
            {
              shop_ids: shop_ids,
              id: this.coupon_id
            }
          ).then(res => {
            if (res) {
              this.$refs.listTable.clearSelection();
              this.$message.success("删除成功！");
              this.getShop(this.coupon_id);
            }
          });
        })
        .catch(() => {});
    }
  }
};
</script>

<style lang="less" scoped>
.coupon-list-body {
  min-height: calc(100vh - 60px);
}
.coupon-input,
.coupon-select {
  width: 110px;
}
</style>